export default "__VITE_ASSET__BEMJ5uTD__"